import type { CandidateSection } from '../../types';
import { subQuestionIds } from './sectionReview';

/**
 * The review marks to store after the candidate's flags changed. A mark is stored on the question that holds the
 * answer: a Reading sub-question belongs to its passage, which counts as marked while any of its questions is.
 * Only questions whose mark changed are returned, so opening a section sends nothing.
 */
export function flagUpdates(
  section: CandidateSection,
  before: ReadonlySet<string>,
  after: ReadonlySet<string>,
): Array<{ questionId: string; flagged: boolean }> {
  const changed = new Set<string>();
  before.forEach((id) => !after.has(id) && changed.add(id));
  after.forEach((id) => !before.has(id) && changed.add(id));
  if (!changed.size) return [];

  const updates = new Map<string, boolean>();
  for (const question of section.questions) {
    const ids = question.type === 'PASSAGE' ? subQuestionIds(question) : [question.id];
    if (!ids.some((id) => changed.has(id))) continue;
    updates.set(question.id, ids.some((id) => after.has(id)));
  }
  return Array.from(updates, ([questionId, flagged]) => ({ questionId, flagged }));
}
